module.exports = __webpack_public_path__ + "img/tbc-0-1.d104651a.webp";